/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Link, { LinkProps } from "@insite/mobius/Link";
import WarehouseModalLocationDirections from "@WhiteCap/Icons/WarehouseModalLocationDirections";
import * as React from "react";

type Props = LinkProps &
{
    iconMode?: boolean,
    iconStyles?: IconPresentationProps,
    address1: string;
    address2?: string;
    city: string;
    state: string;
    postalCode: string;
};

const GoogleMapsDirectionLink: React.FC<Props> = ({
    address1,
    address2,
    city,
    state,
    postalCode,
    target = "_blank",
    iconMode,
    iconStyles,
    ...otherProps
}) => {
    const linkAddress = `http://maps.google.com/maps?daddr=${address1} ${address2}, ${city}, ${state} ${postalCode}`;
    return (
        iconMode ?
            <Link href={linkAddress} target={target}  >
                <Icon {...iconStyles} src={WarehouseModalLocationDirections}></Icon>
            </Link >
            :
            <Link href={linkAddress} target={target} {...otherProps}>
                {translate("Directions")}
            </Link>
    );
};

export default GoogleMapsDirectionLink;
